import { fetchAuthSession } from "@aws-amplify/auth";
import { jwtDecode } from "jwt-decode";

interface DecodedIdToken {
  sub?: string;
  email?: string;
  name?: string;
  given_name?: string;
  family_name?: string;
  "custom:paid"?: string;
}

/**
 * Get the current user ID from the JWT token
 * @returns Promise resolving to the user ID or null if not available
 */
export const getCurrentUserId = async (): Promise<string | null> => {
  try {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString();
    
    if (idToken) {
      const decoded: DecodedIdToken = jwtDecode(idToken);
      return decoded.sub || null;
    }
    
    return null;
  } catch (error) {
    console.error("Failed to retrieve current user ID:", error);
    return null;
  }
}; 